import { styled as o, Box as a } from "@mui/material";
import c from "../../../assets/icons/icon-apeiron-logo-simplified.svg.js";
import x from "../next/Image.js";
import m from "../next/NextLink.js";
import { jsx as t, jsxs as l } from "react/jsx-runtime";
const d = o(a)`
  display: flex;
  color: black;
  font-weight: 700;
  font-size: 20px;
  background-color: white;
  border-radius: 4px;
  padding: 10px 4px;
  height: 50px;
  width: 220px;
  justify-content: center;
  align-items: center;
  gap: 6px;
`, f = o(x)`
  height: 90%;
  aspect-ratio: 0.887;
`, k = (e) => {
  const {
    className: r,
    route: i,
    target: n,
    text: p,
    logo: s
  } = e;
  return /* @__PURE__ */ t(m, {
    href: i || "",
    target: n,
    children: /* @__PURE__ */ l(d, {
      className: r,
      children: [s || /* @__PURE__ */ t(f, {
        src: c
      }), p]
    })
  });
};
export {
  k as default
};
//# sourceMappingURL=ApeironGoToButton.js.map
